import { render, staticRenderFns } from "./import.vue?vue&type=template&id=e22bcde0&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports